import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { supabase } from "../supabase";

const Disciplines = () => {
  const [disciplines, setDisciplines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingDiscipline, setEditingDiscipline] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchDisciplines();
  }, []);

  const fetchDisciplines = async () => {
    try {
      const { data, error } = await supabase.from("disciplines").select("*");
      if (error) throw error;
      setDisciplines(data);
    } catch (error) {
      message.error("Error fetching disciplines");
    } finally {
      setLoading(false);
    }
  };

  const showModal = (discipline = null) => {
    setEditingDiscipline(discipline);
    setIsModalVisible(true);
    if (discipline) {
      form.setFieldsValue(discipline);
    } else {
      form.resetFields();
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    try {
      if (editingDiscipline) {
        const { error } = await supabase
          .from("disciplines")
          .update(values)
          .eq("id", editingDiscipline.id);
        if (error) throw error;
        message.success("Discipline updated successfully");
      } else {
        const { error } = await supabase.from("disciplines").insert([values]);
        if (error) throw error;
        message.success("Discipline added successfully");
      }
      fetchDisciplines();
      handleCancel();
    } catch (error) {
      message.error("Error saving discipline");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button onClick={() => showModal(record)}>Edit</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => showModal()}
        style={{ marginBottom: 16 }}
      >
        Add Discipline
      </Button>
      <Table columns={columns} dataSource={disciplines} loading={loading} rowKey="id" />
      <Modal
        title={editingDiscipline ? "Edit Discipline" : "Add Discipline"}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={form.submit}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please input the name!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please input the description!" }]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Disciplines;
